import { render, staticRenderFns } from "./LevelList.vue?vue&type=template&id=700f2008&scoped=true"
import script from "./LevelList.vue?vue&type=script&lang=js"
export * from "./LevelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f2008",
  null
  
)

export default component.exports